// Path: ./src/app/components/DealProductCard/styled.ts
import styled from "styled-components";

export const Image = styled.img`
  width: 161px;
  margin: 0 auto;
  height: 161px;
  display: flex;
  object-fit: contain;
`;
export const TitleWrapper = styled.div``;
export const Title = styled.div`
  font-size: 14px;
  font-family: system-ui;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const SubTitle = styled.div`
  font-size: 12px;
  font-family: system-ui;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const PriceWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const Sale = styled.div`
  font-size: 16px;
  font-family: system-ui;
  color: red;
`;
export const Was = styled.div`
  font-size: 12px;
  font-family: system-ui;
  color: #8d8d8d;
`;
export const CancelButton = styled.div`
  position: absolute;
  top: -12px;
  right: -8px;
  display: none;
`;
export const AddButton = styled.div`
  position: absolute;
  top: -12px;
  left: -8px;
  display: none;
`;

export const Card = styled.div`
  width: 250px;
  height: 270px;
  border-radius: 29px;
  padding: 10px;
  padding-left: 20px;
  padding-right: 20px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  &:hover {
    box-shadow: 0px 0px 20px -5px #00000033;
  }
`;

export const Container = styled.div`
  width: 250px;
  position: relative;
  &:hover ${CancelButton} {
    display: block;
  }
  &:hover ${AddButton} {
    display: block;
  }
`;
